import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { ferr, date, SearchBar, Table } from "../shared";

const ACTION_STYLES = {
  console_unlock: "bg-sky-100 text-sky-700",
  user_disabled: "bg-rose-100 text-rose-700",
  user_enabled: "bg-emerald-100 text-emerald-700",
  user_deleted: "bg-rose-100 text-rose-700",
  report_requeued: "bg-amber-100 text-amber-700",
  report_completed: "bg-emerald-100 text-emerald-700",
  report_email_resent: "bg-sky-100 text-sky-700",
  report_comped: "bg-violet-100 text-violet-700",
  transaction_refunded: "bg-violet-100 text-violet-700",
  staff_created: "bg-emerald-100 text-emerald-700",
  staff_deleted: "bg-rose-100 text-rose-700",
};

const ActionTag = ({ action }) => (
  <span className={`inline-block px-2 py-0.5 rounded-full text-[11px] font-bold ${ACTION_STYLES[action] || "bg-slate-100 text-slate-600"}`}>
    {String(action || "—").replace(/_/g, " ")}
  </span>
);

export default function AuditPanel() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await api.get("/admin/audit", { params: { q } }); setRows(data); }
    catch (e) { ferr(e, "Failed to load audit log."); } finally { setLoading(false); }
  }, [q]);
  useEffect(() => { const t = setTimeout(load, 250); return () => clearTimeout(t); }, [load]);

  return (
    <div data-testid="admin-audit">
      <SearchBar value={q} onChange={setQ} placeholder="Search by staff, action, target…" testid="admin-audit-search" />
      <Table cols={["When", "Staff member", "Action", "Target", "Detail"]} loading={loading} empty={!rows.length}>
        {rows.map((r, i) => (
          <tr key={i} className="border-t border-gravel hover:bg-fieldstone" data-testid="admin-audit-row">
            <td className="td whitespace-nowrap text-[12px]">{date(r.created_at)}</td>
            <td className="td">{r.actor_email || "—"}</td>
            <td className="td"><ActionTag action={r.action} /></td>
            <td className="td text-[12px] text-mortar max-w-[160px] truncate">{r.target || "—"}</td>
            <td className="td text-[12px] text-mortar max-w-[260px] truncate">{r.detail || "—"}</td>
          </tr>
        ))}
      </Table>
    </div>
  );
}
